/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * @author Gladson Samuel S
 * SkeletonStyles.js
 * Styles for skeleton components
 */

import { makeStyles } from '@material-ui/core';
import mixins from '../../../../assets/styles/mixins.scss';

const cardStyles = {
  card: {
    borderRadius: 16,
    padding: 16,
    backgroundColor: mixins.chalkWhiteFont,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 16,
    width: '100%',

    '& *': {
      boxSizing: 'border-box'
    }
  },
  cardTitle: {
    width: '100%',
    height: 28,
    borderRadius: 8,
    backgroundColor: mixins.color_footer_bgm
  },
  cardContent: {
    width: '100%',
    height: 100,
    borderRadius: 8,
    backgroundColor: mixins.color_footer_bgm,
    minHeight: 128
  },
  content: {}
};

const dashboardCardStyles = {
  container: {
    paddingBottom: 16,
    borderRadius: 24,
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    backgroundColor: mixins.color_footer_bgm,

    '& *': {
      boxSizing: 'border-box'
    }
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    gap: 16
  },
  backButton: {
    width: 24,
    height: 24,
    borderRadius: '50%',
    backgroundColor: mixins.chalkWhiteFont
  },
  dashboardCardTitle: {
    flex: 1,
    height: 28,
    borderRadius: 8,
    backgroundColor: mixins.chalkWhiteFont
  }
};

const listStyles = {
  list: {
    padding: 16,
    borderRadius: 16,
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: mixins.chalkWhiteFont,

    '& *': {
      boxSizing: 'border-box'
    }
  },
  listItem: {
    minHeight: 60,
    display: 'flex',
    alignItems: 'center',
    gap: 48
  },
  listItemContent: {
    display: 'flex',
    alignItems: 'center',
    gap: 24,
    width: '20%'
  },
  listItemAvatar: {
    width: 40,
    height: 40,
    borderRadius: '50%',
    flexShrink: 0,
    backgroundColor: mixins.color_footer_bgm
  },
  listItemTitle: {
    width: '100%',
    height: 28,
    borderRadius: 8,
    backgroundColor: mixins.color_footer_bgm
  },
  listItemBadge: {
    width: '70%',
    height: 28,
    borderRadius: 8,
    backgroundColor: mixins.color_footer_bgm
  },
  listItemProgress: {
    width: '10%',
    height: 28,
    borderRadius: 8,
    backgroundColor: mixins.color_footer_bgm
  }
};

const useSkeletonStyles = makeStyles({
  ...cardStyles,
  ...dashboardCardStyles,
  ...listStyles
});

export default useSkeletonStyles;
